import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const ticket = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 100
        },
        {
            title: '发票记录编号',
            dataIndex: 'invoiceRecordNumber',
            key: 'invoiceRecordNumber',
            scopedSlots: {

                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoiceRecordNumber || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '合同编号',
            dataIndex: 'contractNumbers',
            key: 'contractNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contractNumbers'
            },
            filteredValue: filteredInfo.contractNumber || [],
        },
        {
            title: '发票号码',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoiceNumber || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '发票金额',
            dataIndex: 'invoiceAmount',
            key: 'invoiceAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoiceAmount || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '发票内容',
            dataIndex: 'invoiceContent',
            key: 'invoiceContent',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoiceContent || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '到款是否认领',
            dataIndex: 'payments',
            key: 'claimTheInvoiceFlag',
            scopedSlots: {
                customRender: 'claimTheInvoiceFlag'
            }
        },
        {
            title: '到款总金额',
            dataIndex: 'paymentsAmount',
            key: 'paymentsAmount'
        },
        {
            title: '到款金额',
            dataIndex: 'payments',
            key: 'theAmountReceived',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'paymentAmount'
            },
            filteredValue: filteredInfo['theAmountReceived'] || [],
        },
        {
            title: '到款时间',
            dataIndex: 'payments',
            key: 'arrivalTime',
            scopedSlots: {
                filterDropdown: 'filterTime',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'paymentDate'
            },
            filteredValue: filteredInfo['arrivalTime'] || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '发票类型',
            dataIndex: 'invoiceType',
            key: 'invoiceType',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoiceType|| [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '是否可连号',
            dataIndex: 'connectedFlag',
            key: 'connectedFlag',
            scopedSlots: {
                customRender: 'connectedFlag'
            }
        },
        {
            title: '是否同一天',
            dataIndex: 'sameDayFlag',
            key: 'sameDayFlag',
            scopedSlots: {
                customRender: 'sameDayFlag'
            }
        },
        {
            title: '合同发票总数',
            dataIndex: 'requestNumberOfInvoices',
            key: 'requestNumberOfInvoices'
        },
        {
            title: '发票抬头',
            dataIndex: 'invoiceTitle',
            key: 'invoiceTitle',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
        },

        {
            title: '发票状态',
            dataIndex: 'invoiceStatus',
            key: 'invoiceStatus',
            scopedSlots: {
                filterDropdown: 'filterInvoice',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'invoiceStatus'
            },
            filteredValue: filteredInfo.invoiceStatus || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '退票状态',
            dataIndex: 'refundAuditStatus',
            key: 'refundAuditStatus',
            scopedSlots: {
                filterDropdown: 'filterStatus',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'refundAuditStatus'
            },
            filteredValue: filteredInfo.refundAuditStatus || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '开票单位',
            dataIndex: 'billingUnit.companyName',
            key: 'billingUnitName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo['billingUnitName'] || [],
        },
        {
            title: '开票日期',
            dataIndex: 'invoiceDate',
            key: 'invoiceDate',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '退票申请时间',
            dataIndex: 'refundTime',
            key: 'refundTime',
            scopedSlots: {
              customRender:   'refundTime',
            },
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '退票审核时间',
            dataIndex: 'operatingTime',
            key: 'operatingTime',
            scopedSlots: {
                customRender: 'operatingTime',
            },
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '退票日期',
            dataIndex: 'refundDate',
            key: 'refundDate',
            scopedSlots: {
                customRender: 'refundDate',
            },
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '销售',
            dataIndex: 'sale.name',
            key: 'saleName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo['saleName'] || [],
        },
        {
            title: '初始销售',
            key: 'initialSalesName',
            scopedSlots: {
                customRender: 'createSales'
            }
        },
        {
            title: '客户',
            dataIndex: 'contactName',
            key: 'contactName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contactName'
            },
            filteredValue: filteredInfo.contactName || [],
        },
        {
            title: '负责人',
            dataIndex: 'invoicingPrincipal.name',
            key: 'invoicingPrincipal',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo['invoicingPrincipal'] || [],
        },
        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy || [],
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            // sorter: true,
            // sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '审核状态',
            dataIndex: 'auditStatus',
            key: 'statusType',
            scopedSlots: {
                filterDropdown: 'filterStatus',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'auditStatus'
            },
            filteredValue: filteredInfo.statusType || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
